import waterMark from "../../assets/images/watermark.png";

const addWatermarkToFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");

        // Draw main image
        ctx.drawImage(img, 0, 0);

        // Load watermark
        const watermarkImg = new Image();
        watermarkImg.src = waterMark;

        watermarkImg.onload = () => {
          // Create an offscreen canvas to scale watermark dynamically
          const patternCanvas = document.createElement("canvas");
          const pctx = patternCanvas.getContext("2d");

          // 🔹 Determine scale based on image size
          // Smaller images → smaller watermark tiles
          const minDimension = Math.min(canvas.width, canvas.height);
          let scale = 1.0;

          if (minDimension < 800) scale = 0.25;
          else if (minDimension < 1500) scale = 0.5;
          else if (minDimension < 2500) scale = 0.75;

          patternCanvas.width = watermarkImg.width * scale;
          patternCanvas.height = watermarkImg.height * scale;

          pctx.drawImage(
            watermarkImg,
            0,
            0,
            patternCanvas.width,
            patternCanvas.height
          );

          // Create repeating pattern with scaled watermark
          const pattern = ctx.createPattern(patternCanvas, "repeat");

          ctx.globalAlpha = 0.05; // Adjust watermark transparency
          ctx.fillStyle = pattern;
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.globalAlpha = 1.0;

          // Export final file
          canvas.toBlob(
            (blob) => {
              const watermarkedFile = new File([blob], file.name, {
                type: "image/jpeg",
              });
              resolve(watermarkedFile);
            },
            "image/jpeg",
            0.95
          );
        };

        watermarkImg.onerror = () =>
          reject(new Error("Failed to load watermark image"));
      };

      img.onerror = () => reject(new Error("Failed to load main image"));
      img.src = e.target.result;
    };

    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
};

// const addWatermarkToFile = (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.onload = (e) => {
//       const img = new Image();

//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         canvas.width = img.width;
//         canvas.height = img.height;
//         const ctx = canvas.getContext("2d");

//         // Draw main image
//         ctx.drawImage(img, 0, 0);

//         // Load watermark
//         const watermarkImg = new Image();
//         watermarkImg.src = waterMark;

//         watermarkImg.onload = () => {
//           const tileSize = Math.min(img.width, img.height) * 0.5; // adjust tile scaling

//           // Create an offscreen canvas for a rotated watermark tile
//           const tileCanvas = document.createElement("canvas");
//           tileCanvas.width = tileCanvas.height = tileSize;
//           const tileCtx = tileCanvas.getContext("2d");

//           // Rotate watermark for diagonal look
//           tileCtx.translate(tileSize / 2, tileSize / 2);
//           tileCtx.rotate((-30 * Math.PI) / 180);
//           tileCtx.globalAlpha = 0.2; // transparency of watermark
//           tileCtx.drawImage(
//             watermarkImg,
//             -tileSize / 2,
//             -tileSize / 2,
//             tileSize,
//             tileSize
//           );
//           tileCtx.rotate((30 * Math.PI) / 180);
//           tileCtx.translate(-tileSize / 2, -tileSize / 2);

//           // Create repeating pattern
//           const pattern = ctx.createPattern(tileCanvas, "repeat");
//           ctx.fillStyle = pattern;
//           ctx.globalAlpha = 0.5; // overall watermark opacity
//           ctx.fillRect(0, 0, canvas.width, canvas.height);
//           ctx.globalAlpha = 1.0;

//           // Export to file
//           canvas.toBlob(
//             (blob) => {
//               const watermarkedFile = new File(
//                 [blob],
//                 file.name.replace(/\.[^/.]+$/, ".jpg"),
//                 { type: "image/jpeg" }
//               );
//               resolve(watermarkedFile);
//             },
//             "image/jpeg",
//             0.95
//           );
//         };

//         watermarkImg.onerror = () =>
//           reject(new Error("Failed to load watermark image"));
//       };

//       img.onerror = () => reject(new Error("Failed to load image file"));
//       img.src = e.target.result;
//     };

//     reader.onerror = () => reject(new Error("Failed to read file"));
//     reader.readAsDataURL(file);
//   });
// };

export default addWatermarkToFile;
